const adrListTitleBarMenu = {
  contentType: "adrList",
  menuItems: [],
  toolbar: [
    {
      _iconId: "adrListTitleBarToolbar_0",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "sync-alt",
      toggleValue: null,
      action: "refreshAdrList",
      toolTipText: "Refresh ADR List"
    }
  ]
};

export default adrListTitleBarMenu;
